/**
 * OdysseyModelEmitterUpdateMode enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file OdysseyModelEmitterUpdateMode.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum OdysseyModelEmitterUpdateMode {
  Fountain = 'Fountain',
  Single = 'Single',
  Explosion = 'Explosion',
  Lightning = 'Lightning',
};
